module.exports = __webpack_public_path__ + "075602166efbd21d50a2ec11dd5ae7be.png";